import { InitialState } from "./types"
import { ACTION_TYPES, Actions } from "../actions/types"
import { stateHandler } from "./handler"

export const INITIAL_STATE: InitialState = {
    hash: "",
    id: "",
    publicLink: "",
    isLoaded: false,
    isLoading: false,
    variables: {
        document: {
            pdfUri: ""
        }
    },
    emailSent: 0,
    printUrl: "",
}

export const reducer = (state = INITIAL_STATE, action: Actions) => {
    const handler = stateHandler(state)
    switch (action.type) {
    case ACTION_TYPES.FETCH:
        return handler.fetch()
    case ACTION_TYPES.FETCH_SUCCESS:
        return handler.fetchSuccess(action.payload)
    case ACTION_TYPES.SET:
        return handler.set(action.payload)
    case ACTION_TYPES.SEND_BY_EMAIL:
        return handler.sendByEmail()
    default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/state/proposal/reducers/reducer.ts